// extracted by mini-css-extract-plugin
export var body = "_kx-0";
export var sectionHeader = "_kx-4";
export var shortcutColumns = "_kx-2";
export var shortcutList = "_kx-1";
export var shortcutSection = "_kx-3";